exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card[data-v-3ce9b3ae]{padding:10px;display:-ms-grid;display:grid;-ms-grid-columns:1fr;grid-template-columns:1fr;-ms-grid-rows:159px 1fr 34px;grid-template-rows:159px 1fr 34px;row-gap:13px;text-decoration:none;background-color:#fff;transition:box-shadow .2s ease-in;box-shadow:3px 3px 3px rgba(0,0,0,.1);position:relative}.card[data-v-3ce9b3ae]:hover{box-shadow:3px 3px 3px rgba(0,0,0,.2)}.card__btn[data-v-3ce9b3ae]{justify-self:center}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3ce9b3ae","scoped":true,"hasInlineConfig":true}!./node_modules/stylus-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/parts/competences/card/Card.vue
// module id = 332debbc621a464d7e96
// module chunks = 0